import React, { useRef, useState, useContext, useLayoutEffect, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslate } from '@bynder/localization';

import { IconUpload } from '@bynder/icons';
import { Flex } from '@bynder/design-system';
import { AbilityContext } from '../../abilities/Can';
import { isModule, isView } from '../../helpers/windowLocation';
import { useOutsideClick } from '../../helpers/useOutsideClick';
import { initModalLinks } from '../../legacy/legacy';
import { initUploader } from '../../legacy/uploader/upload';
import { createCFID } from '../../helpers/id';
import { CTADropdown } from './CTADropdown';
import { initToolbar } from '../../legacy/toolbarhelper';
import { iconSizeLarge } from '../../helpers/iconSizes';
import { BREAKPOINTS } from '../../breakpoints';

/*
 * bynder-platform/bynder/views/navigation/header.cfm: 379
 */

export function UploadButton() {
	const ability = useContext(AbilityContext);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const refDropdown = useRef<HTMLUListElement>(null);
	const refButton = useRef<HTMLLIElement>(null);
	const { translate } = useTranslate();

	const redirectUrl = ability.can('show', 'cta_button_redirect') ? '/upload/version/' : '#';
	const buttonId = ability.can('show', 'cta_button_redirect') ? '' : 'uploadMedia';
	const importId = createCFID();

	useEffect(() => {
		if (refButton.current && !isModule('guidelines')) {
			initUploader();
		}
	}, [refButton]);

	useLayoutEffect(() => {
		if (!isModule('guidelines')) {
			initToolbar(translate);
			initModalLinks();
		}
	}, [translate]);

	useOutsideClick(refDropdown, () => {
		setIsDropdownOpen(false);
	});

	const toggleDropdown = () => {
		setIsDropdownOpen((prevState) => !prevState);
	};

	const showDropdownItems =
		isModule('brands') ||
		isModule('media') ||
		isModule('news') ||
		(isModule('account') && isView('dashboard'));

	return (
		<ul className="cta-main-container" id="uploadContainer" ref={refDropdown}>
			<li
				id={buttonId}
				ref={refButton}
				className="btn-upload"
				data-importurl="askserver"
				data-importid={importId}
				data-showcollectionsbox="true"
			>
				<a
					id="anchor-file-selector"
					href={isModule('guidelines') ? '/media?newMedia=true' : redirectUrl}
					title={translate('generalUploadMedia')}
					role="button"
					className="cta-main"
				>
					<span id="upload-button-icon">
						<Flex gap="2" alignItems="center">
							<IconUpload size={iconSizeLarge} />
							<ButtonText>{translate('generalUploadMedia')}</ButtonText>
						</Flex>
					</span>
				</a>
			</li>

			{showDropdownItems && (
				<CTADropdown isDropdownOpen={isDropdownOpen} toggleDropdown={toggleDropdown} />
			)}
		</ul>
	);
}

const ButtonText = styled.span`
	display: none;

	@media (min-width: ${BREAKPOINTS.TABLET}px) {
		display: initial;
	}
`;
